import React, { useCallback, useEffect, useState } from "react";
import { Save, Users, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const SavedGroups = ({ value, onPick, free }) => {
  const [groups, setGroups] = useState([]);
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");
  const load = useCallback(() => api.get("/teacher/diary/groups").then((r) => setGroups(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    try { await api.post("/teacher/diary/groups", { name, student_ids: value }); toast.success(`Group "${name}" saved`); setNaming(false); setName(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save group"); }
  };
  const del = async (g) => { if (window.confirm(`Delete group "${g.name}"?`)) { await api.delete(`/teacher/diary/groups/${g.id}`); load(); } };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="saved-groups">
      {groups.map((g) => {
        const ids = g.student_ids.filter((i) => free.has(i));
        return (
          <span key={g.id} className="flex items-center rounded-full bg-indigo-100 text-xs font-semibold text-indigo-900">
            <button type="button" disabled={!ids.length} onClick={() => onPick(ids)} className="flex items-center gap-1 py-1 pl-3 pr-1 disabled:opacity-40" data-testid={`group-pick-${g.name}`}>
              <Users className="h-3.5 w-3.5" />{g.name} ({ids.length})</button>
            <button type="button" onClick={() => del(g)} className="pr-2 text-indigo-400 hover:text-red-600" aria-label={`Delete group ${g.name}`} data-testid={`group-del-${g.name}`}><X className="h-3 w-3" /></button>
          </span>
        );
      })}
      {value.length > 0 && !naming && <button type="button" onClick={() => setNaming(true)} className="flex items-center gap-1 rounded-full border border-dashed border-indigo-400 px-3 py-1 text-xs font-semibold text-indigo-700" data-testid="group-save-btn">
        <Save className="h-3.5 w-3.5" /> Save these {value.length} as a group</button>}
      {naming && <span className="flex items-center gap-1">
        <input autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} placeholder="Group name e.g. Xavier's Std 6" maxLength={40}
          className="h-8 w-44 rounded border border-slate-300 px-2 text-xs" data-testid="group-name-input" />
        <button type="button" onClick={save} className="text-xs font-bold text-emerald-700" data-testid="group-name-save">Save</button>
        <button type="button" onClick={() => setNaming(false)} className="text-xs text-slate-500">Cancel</button>
      </span>}
    </div>
  );
};
